import React from "react";
import InsightList from "./InsightList";

function InsightAdd() {
  return <InsightList />;
}

export default InsightAdd;
